import { CardElement } from '@stripe/react-stripe-js'
import * as React from 'react'
import styled from 'styled-components'
import { ZentakeContext } from 'utils/ZentakeContext'

import creditCardIcon from '../assets/credit-card.svg'
import ZentakeFormContext from '../components/ZentakeForm/ZentakeFormContext'
import Ui from '.'

const CardElementSkeleton = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding-right: 0.5rem;
  font-size: 0.77rem;
`

const CardElementSkeletonCardNumber = styled.span`
  flex-grow: 1;
  flex-shrink: 1;
`

const CardElementSkeletonCVC = styled.span`
  margin-left: 1rem;
`

const CreditCardIcon = styled.img.attrs(() => ({
  src: creditCardIcon,
  alt: 'credit-card-icon',
}))`
  height: 0.89rem;
  margin-right: 5px;
`

function StripeCard({
  label,
  disabled,
  isRequired,
  filled,
  readOnly,
  error,
  response,
}) {
  const context = React.useContext(ZentakeFormContext)
  const { stripeIntegration, setStripeIntegration } =
    React.useContext(ZentakeContext)
  const stripeError = context?.stripeError
  const stripeEmpty = context?.stripeEmpty
  const emptyError = stripeEmpty && isRequired ? error : null

  React.useEffect(() => {
    if (!stripeIntegration && response?.team_details?.stripe_integration) {
      setStripeIntegration(response?.team_details?.stripe_integration)
    }
  }, [
    response?.team_details?.stripe_integration,
    setStripeIntegration,
    stripeIntegration,
  ])

  const renderCreditCardComponent = React.useCallback(() => {
    const setStripeError = context?.setStripeError ?? (() => {})
    const setStripeEmpty = context?.setStripeEmpty ?? (() => {})

    return filled || readOnly ? (
      <CardElementSkeleton>
        <CreditCardIcon />
        <CardElementSkeletonCardNumber>
          {filled ? '**** **** **** ****' : 'Card number'}
        </CardElementSkeletonCardNumber>
        <span>{filled ? '** / **' : 'MM/YY'}</span>
        <CardElementSkeletonCVC>
          {filled ? '***' : 'CVC'}
        </CardElementSkeletonCVC>
      </CardElementSkeleton>
    ) : (
      <CardElement
        onChange={({ empty, error }) => {
          const shouldNotRegisterError = empty && !isRequired
          if (!shouldNotRegisterError) {
            setStripeError(error?.message)
          }
          setStripeEmpty(empty)
        }}
        options={{
          disabled: disabled || readOnly,
          style: {
            base: {
              '::placeholder': {
                color: 'rgb(117, 117, 117)',
              },
            },
          },
        }}
      />
    )
  }, [
    isRequired,
    context?.setStripeEmpty,
    context?.setStripeError,
    disabled,
    filled,
    readOnly,
  ])

  if (
    !(stripeIntegration?.account_id || stripeIntegration?.api_publishable_key)
  )
    return null

  const STRIPE_ENABLED = process.env.REACT_APP_STRIPE_ENABLED === 'true'

  if (!STRIPE_ENABLED) return null

  return (
    <div>
      {label && (
        <Ui.QuestionTitle isRequired={isRequired}>{label}</Ui.QuestionTitle>
      )}
      {renderCreditCardComponent()}
      {stripeError || emptyError ? (
        <Ui.ErrorLabel>{stripeError || emptyError}</Ui.ErrorLabel>
      ) : null}
    </div>
  )
}

export default StripeCard
